export default "__VITE_ASSET__CWc9KnXP__"